import {get, post} from './base.service'
export default{
    /* 获取就诊卡列表 */
    getVoucherList() {
        return get(`/app/voucher/list?t=${new Date().getTime()}`);
        // 测试桩数据
        // return get(`/app/voucher/list`);
    },
    getFilterVoucherList() {
        return get(`/app/voucher/list/filter?t=${new Date().getTime()}`);
    },
    /* 添加就诊卡 */
    addVoucher(params) {
        return get('/app/voucher/query', {
            params: params
        })
    },
    /* 删除就诊卡 */
    deleteVoucher(params) {
        return post('/app/voucher/del', params)
    },
    /* 获取就诊卡二维码 */
    getVoucherQrCode(params) {
        return get('/app/register/qrCode', {
            params: params
        })
    },
    /* 注册就诊卡 */
    registerVoucher(params) {
        return post('/app/register/virtualCardNew', params)
    },

    getToken(params) {
        return get('/app/user/getToken/{code}',{
            params: params
        });
    }
}



// WEBPACK FOOTER //
// ./src/service/voucher.service.js